// Type predicate to check if the value is a color config
export function isChipColorConfig(appearance) {
  return typeof appearance === "object" && "light" in appearance;
}

// Type predicate to check for full color config
export function isChipColorConfigFull(appearance) {
  return typeof appearance === "object" && "bg" in appearance.light;
}